/* Arranca los videos que sustituyen a los GIFs.

   Estos videos son cortos (1-6 s) y muy livianos (100-380 KB), así que una vez
   visibles se dejan corriendo en bucle igual que hacía el GIF original.
   No se pausan al salir de pantalla: hacerlo provocaba que quedaran congelados
   en el primer fotograma cuando el video es más alto que la ventana. */
(function () {
  var arrancar = function (v) {
    if (v.dataset.gifVideoIniciado) return;
    v.dataset.gifVideoIniciado = '1';
    if (v.preload !== 'auto') v.preload = 'auto';
    var p = v.play();
    if (p && p.catch) {
      p.catch(function () {
        // Si el navegador bloquea la reproducción automática, se reintenta
        // en cuanto el visitante toque o desplace la página.
        delete v.dataset.gifVideoIniciado;
      });
    }
  };

  var iniciar = function () {
    var videos = document.querySelectorAll('video[data-gif-video]');
    if (!videos.length) return;

    var reintentarTodos = function () {
      Array.prototype.forEach.call(videos, function (v) {
        if (v.paused) arrancar(v);
      });
    };

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            arrancar(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '300px 0px', threshold: 0 });

      Array.prototype.forEach.call(videos, function (v) { observer.observe(v); });
    } else {
      reintentarTodos();
    }

    // Red de seguridad: si el navegador bloqueó el autoplay, el primer gesto
    // del visitante lo desbloquea.
    ['touchstart', 'scroll', 'click'].forEach(function (evt) {
      window.addEventListener(evt, reintentarTodos, { once: true, passive: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
